const { fetchJsonApi } = require('./abstract');

const TWITCH_API_URL = 'https://api.twitch.tv/kraken';
const TWITCH_CLIENT_ID = 'jzkbprff40iqj646a697cyrvl0zt2m6';

function fetchStreamStatus(channel) {
  return fetchJsonApi({
    apiUrl: TWITCH_API_URL,
    method: 'GET',
    endpoint: 'streams',
    query: { channel },
    headers: { 'Client-Id': TWITCH_CLIENT_ID },
    expectedStatus: 200,
    description: 'Fetching stream status',
    skipHumanVerification: true,
  });
}

module.exports = {
  fetchStreamStatus,
};
